import { IAppState } from '../../types';

export const selectNewbuildingRecommendationsStatus = (state: IAppState) => {
  return state.newbuildingRecommendations.status;
};
